import axios from "axios"
import { authHeader } from "../../utils"
import { CREATE_TRAIT, CREATING_TRAIT, DELETE_TRAIT, DELETING_TRAIT, GET_TRAITS, GETTING_STUDENT_TRAITS, GET_STUDENT_TRAITS, GETTING_TRAITS, SET_SUCCESS, TRAITS_ERROR, UPDATE_TRAIT, UPDATING_TRAIT, UPDATING_STUDENT_TRAITS, UPDATE_STUDENT_TRAITS } from "../types"


export const createTrait = (traitPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_TRAIT,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/traits`, traitPayload, { headers })
        
        dispatch({
            type: CREATE_TRAIT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New trait created successfully!'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TRAITS_ERROR,
            // payload: error.response.data
            error
        })
    }
}


export const clearCreatedTrait = () => async (dispatch) => {       
    dispatch({
        type: CREATE_TRAIT,
        payload: null
    })
}

export const fetchTraits= (filters, page, perPage, expand) => async dispatch => {    
    try{
        const headers = authHeader()

        let url = `${process.env.REACT_APP_BASE_URL}/traits`

        if(expand && expand !== ''){
            url += `${url.includes('?') ? '&' : '?'}${expand}`
        }

        if(filters && filters !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filters}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_TRAITS,
            payload: true
        })

        const response = await axios.get(`${url}`, { headers })

        dispatch( {
            type: GET_TRAITS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: TRAITS_ERROR,
            // payload: error.response.data,
            error
        })
    }
}

export const fetchStudentTraits= (filters, page, perPage, expand) => async dispatch => {    
    try{
        const headers = authHeader()

        let url = `${process.env.REACT_APP_BASE_URL}/traits/students?expand=traits.trait`

        if(expand && expand !== ''){
            url += `${url.includes('?') ? '&' : '?'}${expand}`
        }

        if(filters && filters !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filters}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_STUDENT_TRAITS,
            payload: true
        })

        const response = await axios.get(`${url}`, { headers })

        dispatch( {
            type: GET_STUDENT_TRAITS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: TRAITS_ERROR,
            // payload: error.response.data,
            error
        })
    }
}


export const updateStudentTraits = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_STUDENT_TRAITS,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/traits/students`, payload, { headers })
        
        dispatch({
            type: UPDATE_STUDENT_TRAITS,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Student traits updated successfully!'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TRAITS_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const clearUpdatedStudentTraits = () => async dispatch => {
    dispatch({
        type: UPDATE_STUDENT_TRAITS,
        payload: null
    })
}

export const clearOnboardedTrait = () => async dispatch => {
    dispatch({
        type: CREATE_TRAIT,
        payload: null
    })
}

export const updateTrait = (id, traitPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_TRAIT,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/traits/${id}`, traitPayload, { headers })
        
        dispatch({
            type: UPDATE_TRAIT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Trait updated successfully'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TRAITS_ERROR,
            // payload: error.response.data
            error
        })
    }
}


export const deleteTrait = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_TRAIT,
            payload: true
        })
        const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/traits/${id}`, { headers })
        
        dispatch({
            type: DELETE_TRAIT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Trait deleted successfully'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TRAITS_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const clearUpdatedTrait = () => async (dispatch) => {       
    dispatch({
        type: UPDATE_TRAIT,
        payload: null
    })
}

export const clearDeletedTrait = () => async (dispatch) => {       
    dispatch({
        type: DELETE_TRAIT,
        payload: null
    })
}